import React from "react";
import { isAssetViewFieldVisible } from "./assetViewFieldConfigUtils";

const AssetViewFieldGate = ({ fieldKey, fieldConfig, configReady = false, children }) => {
    if (!configReady || !fieldConfig?.config) return null;
    if (!isAssetViewFieldVisible(fieldKey, fieldConfig)) return null;
    return <>{children}</>;
};

export default AssetViewFieldGate;
